import { render } from "./index.vue?vue&type=template&id=9d15882a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Legalize/Progresso/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d15882a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d15882a', __exports__)) {
    console.log('reload')
    api.reload('9d15882a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9d15882a", () => {
    console.log('re-render')
    api.rerender('9d15882a', render)
  })

}


export default __exports__